// @flow
import { SORT_DATE, SORT_NAME } from 'constants/sortConstants';

export const EVENT_LIST_OPTIONS = [
  {
    value: SORT_DATE,
    label: 'À venir'
  },
  {
    value: SORT_NAME,
    label: 'Ordre alphabétique'
  }
];

export const INITIAL_EVENTS_DISPLAYED: number = 3;
export const EVENT_FILTERS = [
  { label: 'Tous les évènements', value: 'allEvents' },
  { label: 'Club', value: 'club' },
  { label: 'Match', value: 'match' },
  { label: 'Tournoi', value: 'tournoi' },
];
export const EVENTS_SLUG_TYPE_MATCH = [];
export const EVENT_NAVBAR_SIZE_MOBILE: number = 1280;
